"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'slot.target.client': 'Cliente',
    'slot.target.coworker': 'Collega',
    'slot.target.manager': 'Manager',
    'slot.target.self': 'Io',
};
